export * from './stats';
export * from './utilities/curve-analyzer';
export * from './utilities/basics';
export * from './library/regression.interface';
